import { Img } from 'openimg/react' // Uses the Epic Stack's built-in Icon component
import * as React from 'react'
import { Link } from 'react-router'

const instagramUrl = 'https://instagram.com/steelcitybackgammon'
const facebookUrl = 'https://www.facebook.com/groups/steelcitybackgammon'

export function Footer() {
	return (
		<footer className="container mt-10 flex flex-col p-4">
			<hr className="border-slate-200" />
			<div className="flex items-center justify-between py-2">
				<div className="text-sm italic">© 2026 Steel City Backgammon</div>
				<div className="flex items-center gap-5">
					<div>Follow us:</div>
					<div>
						<Link
							to={instagramUrl}
							target="_blank"
							rel="noopener noreferrer"
							className="group grid leading-snug"
						>
							<Img
								src="/img/instagram-icon-128x128@3x.png"
								width={24}
								height={24}
								fit="cover"
								alt="Instagram logo"
							/>
						</Link>
					</div>
					<div>
						<Link
							to={facebookUrl}
							target="_blank"
							rel="noopener noreferrer"
							className="group grid leading-snug"
						>
							<Img
								src="/img/facebook-logo-square@3x.png"
								className="rounded-md"
								width={24}
								height={24}
								fit="cover"
								alt="Facebook logo"
							/>
						</Link>
					</div>
				</div>
			</div>
			<hr className="border-slate-200" />
		</footer>
	)
}
